import { render, staticRenderFns } from "./SupplierCompaniesCreateEdit.vue?vue&type=template&id=b268a788&scoped=true"
import script from "./SupplierCompaniesCreateEdit.vue?vue&type=script&lang=js"
export * from "./SupplierCompaniesCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./SupplierCompaniesCreateEdit.vue?vue&type=style&index=0&id=b268a788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b268a788",
  null
  
)

export default component.exports